import { CommingSoon } from "./components/CommonComponents/ComingSoon";
import Dashboard from "./components/Dashboard/Dashboard";
import EventMaster from "./components/Master/EventMaster";
import UpdateCandidateData from "./components/Master/UpdateCandidateData";
import UploadCandidateData from "./components/Master/UploadCandidateData";
import UploadCandidateFile from "./components/Master/UploadCandidateFile";
import CandidateReport from "./components/Report/CandidateReport";
import SMSReport from "./components/Report/SMSReport";

const AppRoutes = [
    {
        path: '*',
        element: CommingSoon
    }, {
        path: '/Master/Eventmaster',
        element: EventMaster
    }, {
        path: '/Dashboard/Dashboard',
        element: Dashboard
    }, {
        path: '/Upload/UploadCandidateFile',
        element: UploadCandidateFile
    }, {
        path: '/Update/UpdateCandidateData',
        element: UpdateCandidateData
    }, {
        path: '/Upload/UploadCandidateData',
        element: UploadCandidateData
    }, {
        path: 'Report/CandidateReport',
        element: CandidateReport
    }, {
        path: 'Report/SMSReport',
        element: SMSReport
    }
];

export default AppRoutes;
